import { HeaderAdapter as Header } from "./Header";

export { Header };
